import { render } from "./Resource.vue?vue&type=template&id=1d099f48&ts=true"
import script from "./Resource.vue?vue&type=script&lang=ts"
export * from "./Resource.vue?vue&type=script&lang=ts"

import "./Resource.vue?vue&type=style&index=0&id=1d099f48&lang=css"

import exportComponent from "D:\\Work\\IMMS\\IMMSV3\\App\\IMMS.MasterClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Resource.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d099f48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d099f48', __exports__)) {
    console.log('reload')
    api.reload('1d099f48', __exports__)
  }
  
  module.hot.accept("./Resource.vue?vue&type=template&id=1d099f48&ts=true", () => {
    console.log('re-render')
    api.rerender('1d099f48', render)
  })

}


export default __exports__